import { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import CreationFormWrapper from "../../actprep-ui/components/CreationFormWrapper";
import { usePost, usePut } from "../../actprep-ui/hooks/api";
import { apiUrls } from "../../actprep-ui/utils/urls";
import { showSuccessSnackbar } from "../../actprep-ui/utils/feedback";

export default function ProgramForm({
  open,
  setOpen,
  initialValue,
  setValue,
  initialUUID,
}) {
  const editing = Boolean(initialUUID);
  const createProgramMutation = usePost(apiUrls.admin.programs());
  const editProgramMutation = usePut(apiUrls.admin.programs());
  const [formData, setFormData] = useState({
    title: "",
  });
  const handleFocus = () => setError(null);
  const [error, setError] = useState(null);
  const handleClose = () => {
    setOpen(false);
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    let response;
    if (editing) {
      response = await editProgramMutation.mutateAsync({
        ...formData,
        program_uuid: initialUUID,
      });
    } else {
      response = await createProgramMutation.mutateAsync(formData);
    }
    const { data } = response;
    if (!data.success) {
      setError(data.reason);
      return;
    }
    setValue({
      uuid: data.program.uuid,
      label: data.program.__str__,
    });
    setOpen(false);
    if (editing) {
      showSuccessSnackbar("Program Updated!");
      return;
    }
    showSuccessSnackbar("New Program Created!");
  };

  useEffect(() => {
    if (open) {
      setFormData((formData) => ({
        ...formData,
        title: initialValue,
      }));
    }
  }, [open, initialValue]);

  return (
    <CreationFormWrapper
      open={open}
      onClose={handleClose}
      onSubmit={onSubmit}
      error={error}
      title={
        editing ? `Editing '${initialValue}' Program` : "Add a new Program"
      }
      confirmText={editing ? "Save" : "Create"}
    >
      <Grid container gap={3} marginTop={1}>
        <Grid size={12}>
          <TextField
            fullWidth
            autoFocus
            value={formData.title}
            onChange={(event) =>
              setFormData({
                ...formData,
                title: event.target.value,
              })
            }
            label="Title"
            type="text"
            variant="standard"
            onFocus={handleFocus}
          />
        </Grid>
      </Grid>
    </CreationFormWrapper>
  );
}
